module.exports = __webpack_public_path__ + "img/3.e748b33f.png";